module.exports = __webpack_public_path__ + "img/CZlogo.8c4b7860.png";